import { Component } from '@angular/core';
import { AuthService } from '../services/authentication/auth.service';
import { AlertService } from '../services/alert.service';

export class ViewBaseComponent { 
    
    constructor(
    	protected authService: AuthService,
    	protected alertService: AlertService) {
    }

    handleError(error) {
        if (error.error != null) {
            if (error.error.Code == 403) {
              this.authService.logoutUser(true);
            } else {
              this.alertService.error(`Error : ${error.message}`);
            }
        } else {
            this.alertService.error(`Error : ${error}`);
        }
    }       
} 